var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M5.427,7.082c1.158,1.034,1.885.182,1.885.182-.432.914-1.46.424-1.46.424L4.636,6.9C2.86,5.694,1.96,6.9,1.96,6.9a2.055,2.055,0,0,1,1.764.666A16.283,16.283,0,0,0,5.183,8.9C6.476,9.966,8.1,8.839,8.1,8.839a1.615,1.615,0,0,0,.487-2.544A6.7,6.7,0,0,0,6.278,4.962C5.43,4.8,5.61,3.749,5.61,3.749a3.976,3.976,0,0,1,.3-.848,1.441,1.441,0,0,0-.731-1.756c.027-.4.547-.121.547-.121.558.829.973.3.973.3-.5-.01-.547-.545-.547-.545C6-.148,5.487-.006,5.487-.006,4.6-.063,4.94,1.145,4.94,1.145c-1.427.038-1.277,1.03-1.277,1.03L3.6,2.781c-.415,1.261.243,1.393.243,1.393.62.276,1.216-.424,1.216-.424-.134.645-1.095.787-1.095.787l-1.46.424C.134,5.5.014,7.263.014,7.263A1.59,1.59,0,0,0,1.048,8.717a3.773,3.773,0,0,0,2.858-.363C3.448,6.842,1.656,7.2,1.656,7.2l.122-.424c.28-.67,1.107-.724,1.608-.68A3.89,3.89,0,0,1,5.427,7.082ZM1.6,9.2a3.955,3.955,0,0,0,2.676-.666A3.028,3.028,0,0,0,6.947,9.747,2.7,2.7,0,0,0,6.1,12.776l.061.788a1.231,1.231,0,0,1-.912,1.212s-.826.306-.73.666a1.049,1.049,0,0,0,.182.545.679.679,0,0,1,0-1.333l.486-.242s.776-.461.061-1.212a2.448,2.448,0,0,0-1.155-.485s-1.5-.346-1.885-1.03A4.378,4.378,0,0,1,1.6,9.2Z",
    transform: "translate(18.986 0.014)",
    fill: "#e4af40",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.963b2bbda679b097cc0285f3b2e00610.svg";
export { ForwardRef as ReactComponent };